import { render, staticRenderFns } from "./LinkItem.vue?vue&type=template&id=84c3cab4&"
import script from "./LinkItem.vue?vue&type=script&lang=ts&"
export * from "./LinkItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports